import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AccountRoutingModule } from './account-routing.module';
import { MasterRoutingModule } from '@app/master/master-routing.module';
import { AppSharedModule } from '@app/shared/app-shared.module';
import { AppCommonModule } from '@app/shared/common/app-common.module';
import { SubheaderModule } from '@app/shared/common/sub-header/subheader.module';
import { FormsModule } from '@angular/forms';
import { Angular2CountoModule } from '@awaismirza/angular2-counto';
import { BsDatepickerModule, BsDatepickerConfig, BsDaterangepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'primeng/tooltip';
import { UtilsModule } from '@shared/utils/utils.module';
import { NgxBootstrapDatePickerConfigService } from 'assets/ngx-bootstrap/ngx-bootstrap-datepicker-config.service';
import { AccountGroupsComponent } from './accountGroups/accountGroups.component';
import { CreateOrEditAccountGroupModalComponent } from './accountGroups/create-or-edit-accountGroup-modal.component';
import { AccountSubGroupsComponent } from './accountSubGroups/accountSubGroups.component';
import { CreateOrEditAccountSubGroupModalComponent } from './accountSubGroups/create-or-edit-accountSubGroup-modal.component';
import { ChartOfAccountsComponent } from './chartOfAccounts/chartOfAccounts.component';
import { CreateOrEditChartOfAccountComponent } from './chartOfAccounts/create-or-edit-chartOfAccount.component';
import { FileUpload, FileUploadModule } from 'primeng/fileupload';

import { CreateOrEditJournalVoucherComponent } from './journalVoucher/create-or-edit-journalvoucher.component';
import { JournalVouchersComponent } from './journalVoucher/journalvouchers.component';

import { PostedJournalVouchersComponent } from './postedJournalVoucher/postedjournalvouchers.component';
import { CreateOrEditPurchaseNotesComponent } from './purchaseNotes/create-or-edit-purchasenotes.component';
import { PurchaseNotesComponent } from './purchaseNotes/purchasenotes.component';
import { BalanceSheetComponent } from './reports/balance-sheet/balance-sheet.component';
import { GeneralLedgerComponent } from './reports/general-ledger/general-ledger.component';
import { ProfitAndLossComponent } from './reports/profit-and-loss/profit-and-loss.component';
import { TrialBalanceComponent } from './reports/trial-balance/trial-balance.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';

import { SalesNotesComponent } from './salesNotes/salesnotes.component';
import { CreateOrEditSalesNotesComponent } from './salesNotes/create-or-edit-salesnotes.component';


@NgModule({
  declarations: [AccountGroupsComponent,
    CreateOrEditAccountGroupModalComponent,
    AccountSubGroupsComponent,
    CreateOrEditAccountSubGroupModalComponent,
    ChartOfAccountsComponent,
    CreateOrEditChartOfAccountComponent,
    CreateOrEditJournalVoucherComponent,
    JournalVouchersComponent,
    PostedJournalVouchersComponent,
    CreateOrEditPurchaseNotesComponent,
    PurchaseNotesComponent,
    BalanceSheetComponent,
    GeneralLedgerComponent,
    ProfitAndLossComponent,
        TrialBalanceComponent,
        SalesNotesComponent,
        CreateOrEditSalesNotesComponent
  ],
    imports: [
          CommonModule,
          FormsModule,
          ModalModule,
          TabsModule,
          TooltipModule,
          AppCommonModule,
          UtilsModule,
          AccountRoutingModule,
          AppSharedModule, 
          FileUploadModule,
          MultiSelectModule,
          CalendarModule,
          CardModule,
          Angular2CountoModule,
          BsDatepickerModule.forRoot(),
          BsDropdownModule.forRoot(),
          PopoverModule.forRoot(),
          SubheaderModule,
    ],
    providers: [
            { provide: BsDatepickerConfig, useFactory: NgxBootstrapDatePickerConfigService.getDatepickerConfig },
            { provide: BsDaterangepickerConfig, useFactory: NgxBootstrapDatePickerConfigService.getDaterangepickerConfig },
            { provide: BsLocaleService, useFactory: NgxBootstrapDatePickerConfigService.getDatepickerLocale },
        ],
})
export class AccountModule { }
